import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import { updateUserProfile } from '@/services/core.service'
import { useOIDCStore } from '@/stores/oidc.store'
import type { IUpdateUserProfileForm } from '@/types/core/forms'
import { useMutation } from '@tanstack/vue-query'

export const useUsersProfile = () => {
  const oidcStore = useOIDCStore()

  const updateProfileMutation = useMutation({
    mutationFn: (form: IUpdateUserProfileForm) => updateUserProfile(form),
    onError: NotifyErrorWrapper('Failed to update profile'),
    onSuccess: async () => {
      await oidcStore.loadUserProfile()
      NotifySuccess(`Profile updated`)
    },
  })

  return {
    updateProfileMutation,
  }
}
